import React from 'react';

const TitleText = ({children, index, indexProgress}) => {

    const cssClass = index === indexProgress ? ' labelTitleActive text-center' : 'labelTitle text-center';

    return (
        <div className={cssClass}>{children}
       </div>
        
    );
}

export default TitleText;
